"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireWildcard(require("lodash"));

var _operators = require("rxjs/operators");

var _rxjs = require("rxjs");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = function _default(isProduction, log) {
  var dispatch;

  var update$ = _rxjs.Observable.create(function (observer) {
    dispatch = function dispatch(action) {
      return observer.next(action);
    };
  }).pipe( // Forces every value to get rendered before next value is calculated
  (0, _operators.observeOn)(_rxjs.queueScheduler), // Delay allows state to update in between the dispatches. 
  // If dispatch is able to continuously dispatch, a bug can occur where the lateststate does not update in between which can causing overriding of state values
  (0, _operators.delay)(1), (0, _operators.share)());

  update$.subscribe(function (event) {
    if (!isProduction && log) {
      console.log("%cDispatch:", 'background: green; color: white');
      console.log(event);
    }
  });

  var checkId = function checkId(id, updateId) {
    if (!_lodash["default"].isNil(id)) {
      var idTags = id.split('.');
      var updateTags = updateId.split('.');
      return idTags.reduce(function (acc, next, index) {
        return acc ? updateTags[index] === next || next === '*' : false;
      }, true);
    } else {
      return EMTPY;
    }
  }; // export const getId = (id) => update$
  //   .pipe(
  //     filter(update => checkId(id, update.id)),
  //     map(e => e.id)
  //   )
  // export const getActionWithMeta = (id, action) => update$
  // .pipe(
  //   filter(update => {
  //     const exists = checkId(id, update.id)
  //     return action ? exists && update.action === action : exists
  //   }
  //   )
  // )


  var getAction = function getAction(listener) {
    if (!isProduction && _lodash["default"].isNil(listener)) {
      console.log("ID IS UNDEFINED IN GETACTION2");
    }

    var id = listener ? listener : '';
    var starred = id.substring(id.length - 2, id.length) === '.*';
    return update$.pipe((0, _operators.filter)(function (update) {
      if (starred) {
        var unstarredId = id.replace('.*', '');
        var listenerSubstring = unstarredId.split('.');
        var updateSubstring = update.id.split('.');
        return listenerSubstring.reduce(function (acc, next, index) {
          return acc && updateSubstring[index] === next;
        }, true);
      } else {
        return id === update.id;
      }
    }), (0, _operators.map)(function (update) {
      if (!starred) {
        return update.value;
      } else {
        var unstarredId = id.replace('.*', '');
        var updatedId = update.id.replace(unstarredId, '');

        if (updatedId.substring(0, 1) === '.') {
          updatedId = updatedId.substring(1, updatedId.length);
        }

        return {
          id: updatedId,
          value: update.value
        };
      }
    }));
  };

  var nextAction = function nextAction(id, value) {
    return dispatch({
      id: id,
      value: value
    });
  };

  return {
    nextAction: nextAction,
    getAction: getAction
  };
};

exports["default"] = _default;
//# sourceMappingURL=Dispatcher.js.map